import request from "@/service";

/* 查询审核列表 */
export function enrollAuditList(data) {
  return request({
    url: "/study/audit/enroll/page",
    method: "get",
    params: data
  });
}

// 获取审核记录
export function auditHistoryList(id) {
  return request({
    url: `/study/audit/enroll/list/${id}`,
    method: "get"
  });
}

// 更新审核记录
export function auditHistoryUpdate(data) {
  return request({
    url: `/study/audit/enroll/update`,
    method: "put",
    data
  });
}
